/**
 * Grid iteration order for Pot Collection coin processing.
 *
 * Used by: EOB value collection, Collect feature trails, Double feature trails.
 * Single source of truth — change here to affect all three.
 *
 * Current order: HORIZONTAL (row-by-row)
 *   Row 0: [0,0] [1,0] [2,0] [3,0] [4,0]
 *   Row 1: [0,1] [1,1] [2,1] [3,1] [4,1]
 *   Row 2: [0,2] [1,2] [2,2] [3,2] [4,2]
 */

/**
 * Sort coins in horizontal grid order: row-by-row (symbolIndex first), left-to-right within each row.
 * @param {Array<{reelIndex: number, symbolIndex: number}>} coins
 * @returns {Array} New sorted array (does not mutate input)
 */
export const sortGridOrder = (coins) =>
  [...coins].sort((a, b) => {
    if (a.symbolIndex !== b.symbolIndex) return a.symbolIndex - b.symbolIndex;
    return a.reelIndex - b.reelIndex;
  });
